export default __webpack_public_path__ + "static/media/blog2.391c9853.png";